export default __webpack_public_path__ + "static/media/No40Closed.ed6644a1.jpg";